module.exports = __webpack_public_path__ + "static/img/hong-bg.e1cff28.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/hong-bg.png
// module id = e55q
// module chunks = 4